import React from 'react';
import '../styles/main.css';

interface GenderSelectorProps {
    value?: string;
    onChange: (value: string) => void;
    label?: string;
}

const OPTIONS = [
    { value: 'male', label: '男' },
    { value: 'female', label: '女' },
    { value: 'secret', label: '保密' },
];

export const GenderSelector: React.FC<GenderSelectorProps> = ({ value = 'secret', onChange, label }) => {
    return (
        <div className="auth-input-group">
            {label && <label className="auth-label-static">{label}</label>}
            <div className="gender-selector-container">
                {OPTIONS.map((option) => (
                    <button
                        key={option.value}
                        type="button" // Prevent form submission
                        className={`gender-option ${value === option.value ? 'active' : ''}`}
                        onClick={() => onChange(option.value)}
                    >
                        {option.label}
                    </button>
                ))}
                <div
                    className="gender-highlight"
                    style={{
                        transform: `translateX(calc(${OPTIONS.findIndex(o => o.value === value) * 100}% + ${OPTIONS.findIndex(o => o.value === value) * 4}px))`
                    }}
                />
            </div>
        </div>
    );
};
